const company = {
  company: {
    pageHeader: 'Company Profile',
    branchProfile: 'Branch Profile',
    addBranchOffice: 'Add Branch Office',
    companyDetails: 'Company Details',
    branchDetails: 'Branch Details',
    companyName: 'Company Name',
    chamberofcommerce : 'Chamber of Commerce Number',
    branchName: 'Branch Name',
    websiteURL: 'Website URL',
    url: 'URL',
    yearFounded: 'Year Founded',
    companyLogo: 'Company Logo',
    imageFormatDescription: 'Must be a JPEG, GIF, or PNG file no larger than 4MB.',
    imageShapeDescription:
      'For best results, we recommend a square image with a transparent background at least 400px wide by 400px tall.',
    noFile: 'No file selected',
    companyDescription: 'Company Description',
    myTestEdit: 'My Test Edit',
    customerWelcomeEmail: 'Customer Welcome Email Message',
    testEditMessage: 'test edit email message',
    companyDescriptionTooltip:
      'Text entered here will appear on the public views of systems installed by your company. You may wish to include contact information to help generate sales leads from visitors to these pages.',
    editCompanyInformation: 'Edit Company Information',
    welcomeEmailDescription:
      'Text entered here will appear in the welcome email that is sent to new customers when an Enlighten account is created. You may choose to include your company logo with this message.',
    editWelcomeMessage: 'Edit Customer Welcome Email Message',
    checkboxDisplayLogo: 'Display company logo in customer welcome email',
    previewEmail: 'Preview Customer Welcome Email',
    contactDetails: 'Contact Details',
    streetAddress: 'Street Address',
    streetAddress2: 'Street Address 2',
    city: 'City',
    zipCode: 'Zip/Postal Code',
    customerSupport: 'Customer Support Contacts',
    country: 'Country',
    state: 'State/Province',
    contactOwnerDescription: 'for System Owner / Home Owner to contact',
    businessContacts: 'Business Contacts',
    sameCheckbox: 'Same as customer Support',
    contactEnphaseDescription: 'for Enphase to contact',
    installationDetails: 'Installation Details',
    servicesOffered: 'Services Offered',
    installationType: 'Installation Type',
    salesEmployeeNumber: 'Number of employees in Sales',
    workmanshipWarranty: 'Workmanship Warranty Offered (Year)',
    installationEmployeeNumber: 'Number of Employees doing Installations',
    typicalInstallationsYear: 'Typical Installations (per Year)',
    typicalInstallationsMonth: 'Typical Installations (kW / Month)',
    enphaseShare: 'Enphase Share in installations',
    sgipDeveloper: 'Are you an SGIP developer?',
    sgipDeveloperTooltip: 'Select if you are registered as an SGIP Developer on selfgenca.com',
    fein_ein: 'FEIN/EIN',
    sgipDeveloperKey: 'SGIP Developer Key',
    businessLicenses: 'Business Licenses',
    addNewLicense: 'ADD NEW LICENSE',
    licenseType: 'License Type',
    licenseNo: 'License No',
    none: 'None',
    licensingBoard: 'Licensing Board',
    licensingAuthority: 'Licensing Authority',
    expiryDate: 'Expiry Date',
    profileLinks: 'Profile Links',
    yelpAccountLink: 'Yelp Account Link',
    rating: 'Rating: ',
    reviews: 'Reviews: ',
    yelpAccountLinkTooltip:
      'To get this link, go to your Yelp profile and copy the link/URL in the address bar of your internet browser',
    yelpAccountLinkError: 'We were not able to get your yelp profile. Please recheck the profile link entered by you',
    googlePlaceId: 'Google Place ID',
    clickHere: 'Click here',
    findPlaceId: 'to find your google place ID',
    placeIdError: 'We were not able to find a valid location for this ID. Please recheck the ID entered by you.',
    solarProfileLink: 'SolarReviews Profile Link',
    solarProfileLinkTooltip:
      'To get this link, go to your SolarReviews.com profile and copy the link/URL in the address bar of your internet browser',
    bbbProfileLink: 'BBB Profile Link',
    bbbProfileLinkTooltip:
      'To get this link, go to your BBB.org profile and copy the link/URL in the address bar of your internet browser',
    solarQuotesProfileLink: 'Solarquotes Profile Link',
    solarQuotesTooltip:
      'To get this link, go to your solarquotes.com.au profile and copy the link/URL in the address bar of your internet browser',
    productReviewProfileLink: 'ProductReview Profile Link',
    productReviewTooltip:
      'To get this link, go to your productreview.com.au profile and copy the link/URL in the address bar of your internet browser',
    trustPilotLink: 'Trustpilot Profile Link',
    trustPilotTooltip:
      'To get this link, go to your trustpilot.com profile and copy the link/URL in the address bar of your internet browser',
    facebookLink: 'Facebook Profile Link',
    facebookTooltip:
      'To get this link, go to your facebook.com profile and copy the link/URL in the address bar of your internet browser',
    justDialLink: 'Just Dial Profile Link',
    justDialTooltip:
      'To get this link, go to your justdial.com profile and copy the link/URL in the address bar of your internet browser',
    listOfReferenceSystems: 'List of Reference Systems',
    referenceListDescription:
      'Your reference list automatically updates to showcase systems that owners have opted to share. Systems listed have at least 100kWh of lifetime energy',
    requestSystemAccess: 'Request System Access',
    maintainer: 'Maintainer',
    view_only: 'View Only',
    linkRequestAccess: 'Send this link to system owners to request access to their system in Enlighten',
    fieldRequired: 'This field is required.',
    validEmail: 'Please enter a valid email address.',
    validPhone: 'Please enter a valid phone number.',
    supportContact: 'Please fill at least one of the above fields (Phone/Email).',
    serviceRequired: 'Atleast one service type is required',
    installationRequired: 'Atleast one installation type is required',
    minLength: 'Minimum allowed length is 2',
    maxLength: 'Maximum allowed length is 15',
    dateWarning: 'Warning: This license will be considered as expired as expiry date is in the past',
    correctValue: 'Please enter a value less than or equal to ',
    feinLength: 'Please enter a 9 digit number',
    less_than_25: 'Less than 25%',
    between_25_50: '25% to 50%',
    between_50_90: '50% to 90%',
    greater_than_90: 'Greater than 90%',
    // TODO - new translations added (from french)
    roofingFr: 'QualiPV Bâtiment',
    solarFr: 'QualiPV Electricité (inférieur ou égale à 36kVA)',
    storageFr: 'QualiPV Electricité (supérieur à 36kVA ou inférieur ou égale à 250kVA)',
    electricalFr: 'QualiPV Electricité (supérieur à 250kVA)',
    othersFr: 'Autres',
    // TODO - new translations added (from french)
    roofing: 'Roofing',
    solar: 'Solar',
    storage: 'Storage',
    electrical: 'Electrical',
    ev_charger: 'EV Charger',
    others: 'Others',
    commercial: 'Commercial',
    residential: 'Residential',
    new_homes: 'New Homes',
    installer: 'Installer',
    roles_distributor: 'Distributor',
    roles_support: 'Support Company',
    cec: 'CEC',
    electrical_contract: 'Electrical Contract',
    abn_number: 'ABN Number',
    acn_number: 'ACN Number',
    installateurverzeichniss_elektro_eintrag: 'Installateurverzeichniss Elektro Eintrag',
    sgze: 'SGZE',
    zonnekeur: 'Zonnekeur',
    holland_solar: 'Holland Solar',
    techniek_nederland: 'Techniek Nederland',
    installq: 'InstallQ',
    fedelec: 'Fedelec',
    pv_vlaanderen: 'PV Vlaanderen',
    selectCountry: 'Please Select Country',
    yellowPageLink: 'Yellow page link',
    yellowPageTooltip: `To obtain this link, go to your profile https://www.pagesjaunes.fr/ and copy the link / URL in the address bar of your Internet browser.`,
    enrQualityDirectoryLink: 'Annuary Qualit’Enr',
    enrQualityDirectoryTooltip: `To obtain this link, go to your profile https://www.qualit-enr.org/annuaire/ and copy the link / URL into the address bar of your Internet browser.`,
    validChamberNumber: 'Invalid Input! Minimum 8 characters required for Chamber of Commerce Number',  
}
};

export default company;
